import { Add_exports } from "../icons/Add.svg_component.js";
import { AddTab_exports } from "../icons/AddTab.svg_component.js";
import { Alert_exports } from "../icons/Alert.svg_component.js";
import { ArrowLeft_exports } from "../icons/ArrowLeft.svg_component.js";
import { ArrowRight_exports } from "../icons/ArrowRight.svg_component.js";
import { Brackets_exports } from "../icons/Brackets.svg_component.js";
import { Branch_exports } from "../icons/Branch.svg_component.js";
import { Changelog_exports } from "../icons/Changelog.svg_component.js";
import { Checkmark_exports } from "../icons/Checkmark.svg_component.js";
import { ChevronDown_exports } from "../icons/ChevronDown.svg_component.js";
import { ChevronLeft_exports } from "../icons/ChevronLeft.svg_component.js";
import { ChevronRight_exports } from "../icons/ChevronRight.svg_component.js";
import { ChevronUp_exports } from "../icons/ChevronUp.svg_component.js";
import { Clipboard_exports } from "../icons/Clipboard.svg_component.js";
import { Close_exports } from "../icons/Close.svg_component.js";
import { CloseTab_exports } from "../icons/CloseTab.svg_component.js";
import { CloseTabs_exports } from "../icons/CloseTabs.svg_component.js";
import { Cloud_exports } from "../icons/Cloud.svg_component.js";
import { CodeFolder_exports } from "../icons/CodeFolder.svg_component.js";
import { Cog_exports } from "../icons/Cog.svg_component.js";
import { Collection_exports } from "../icons/Collection.svg_component.js";
import { Cookie_exports } from "../icons/Cookie.svg_component.js";
import { DarkMode_exports } from "../icons/DarkMode.svg_component.js";
import { Delete_exports } from "../icons/Delete.svg_component.js";
import { Discord_exports } from "../icons/Discord.svg_component.js";
import { DocsPage_exports } from "../icons/DocsPage.svg_component.js";
import { Download_exports } from "../icons/Download.svg_component.js";
import { Duplicate_exports } from "../icons/Duplicate.svg_component.js";
import { Edit_exports } from "../icons/Edit.svg_component.js";
import { Ellipses_exports } from "../icons/Ellipses.svg_component.js";
import { Email_exports } from "../icons/Email.svg_component.js";
import { Error_exports } from "../icons/Error.svg_component.js";
import { Example_exports } from "../icons/Example.svg_component.js";
import { ExternalLink_exports } from "../icons/ExternalLink.svg_component.js";
import { FilterList_exports } from "../icons/FilterList.svg_component.js";
import { Folder_exports } from "../icons/Folder.svg_component.js";
import { GitHub_exports } from "../icons/GitHub.svg_component.js";
import { GitHubLine_exports } from "../icons/GitHubLine.svg_component.js";
import { Globe_exports } from "../icons/Globe.svg_component.js";
import { Google_exports } from "../icons/Google.svg_component.js";
import { Help_exports } from "../icons/Help.svg_component.js";
import { Hide_exports } from "../icons/Hide.svg_component.js";
import { History_exports } from "../icons/History.svg_component.js";
import { House_exports } from "../icons/House.svg_component.js";
import { Import_exports } from "../icons/Import.svg_component.js";
import { Info_exports } from "../icons/Info.svg_component.js";
import { Key_exports } from "../icons/Key.svg_component.js";
import { Leave_exports } from "../icons/Leave.svg_component.js";
import { LightDarkModeToggle_exports } from "../icons/LightDarkModeToggle.svg_component.js";
import { LightMode_exports } from "../icons/LightMode.svg_component.js";
import { Link_exports } from "../icons/Link.svg_component.js";
import { Lock_exports } from "../icons/Lock.svg_component.js";
import { Logo_exports } from "../icons/Logo.svg_component.js";
import { Magic_exports } from "../icons/Magic.svg_component.js";
import { Markdown_exports } from "../icons/Markdown.svg_component.js";
import { Menu_exports } from "../icons/Menu.svg_component.js";
import { NotAllowed_exports } from "../icons/NotAllowed.svg_component.js";
import { Page_exports } from "../icons/Page.svg_component.js";
import { Pencil_exports } from "../icons/Pencil.svg_component.js";
import { Play_exports } from "../icons/Play.svg_component.js";
import { Refresh_exports } from "../icons/Refresh.svg_component.js";
import { Roadmap_exports } from "../icons/Roadmap.svg_component.js";
import { Scribble_exports } from "../icons/Scribble.svg_component.js";
import { Search_exports } from "../icons/Search.svg_component.js";
import { Server_exports } from "../icons/Server.svg_component.js";
import { Settings_exports } from "../icons/Settings.svg_component.js";
import { Show_exports } from "../icons/Show.svg_component.js";
import { Sort_exports } from "../icons/Sort.svg_component.js";
import { Terminal_exports } from "../icons/Terminal.svg_component.js";
import { Trash_exports } from "../icons/Trash.svg_component.js";
import { Unlock_exports } from "../icons/Unlock.svg_component.js";
import { Unwatch_exports } from "../icons/Unwatch.svg_component.js";
import { Upload_exports } from "../icons/Upload.svg_component.js";
import { User_exports } from "../icons/User.svg_component.js";
import { UserSwitch_exports } from "../icons/UserSwitch.svg_component.js";
import { Users_exports } from "../icons/Users.svg_component.js";
import { Versions_exports } from "../icons/Versions.svg_component.js";
import { Wallet_exports } from "../icons/Wallet.svg_component.js";
import { Watch_exports } from "../icons/Watch.svg_component.js";
import { Workspace_exports } from "../icons/Workspace.svg_component.js";
import { programming_framework_angular_exports } from "../icons/programming-framework-angular.svg_component.js";
import { programming_framework_astro_exports } from "../icons/programming-framework-astro.svg_component.js";
import { programming_framework_laravel_exports } from "../icons/programming-framework-laravel.svg_component.js";
import { programming_framework_nextdotjs_exports } from "../icons/programming-framework-nextdotjs.svg_component.js";
import { programming_framework_react_exports } from "../icons/programming-framework-react.svg_component.js";
import { programming_framework_vuedotjs_exports } from "../icons/programming-framework-vuedotjs.svg_component.js";
import { programming_language_c_exports } from "../icons/programming-language-c.svg_component.js";
import { programming_language_clojure_exports } from "../icons/programming-language-clojure.svg_component.js";
import { programming_language_csharp_exports } from "../icons/programming-language-csharp.svg_component.js";
import { programming_language_css3_exports } from "../icons/programming-language-css3.svg_component.js";
import { programming_language_dart_exports } from "../icons/programming-language-dart.svg_component.js";
import { programming_language_fsharp_exports } from "../icons/programming-language-fsharp.svg_component.js";
import { programming_language_go_exports } from "../icons/programming-language-go.svg_component.js";
import { programming_language_html5_exports } from "../icons/programming-language-html5.svg_component.js";
import { programming_language_http_exports } from "../icons/programming-language-http.svg_component.js";
import { programming_language_java_exports } from "../icons/programming-language-java.svg_component.js";
import { programming_language_javascript_exports } from "../icons/programming-language-javascript.svg_component.js";
import { programming_language_json_exports } from "../icons/programming-language-json.svg_component.js";
import { programming_language_julia_exports } from "../icons/programming-language-julia.svg_component.js";
import { programming_language_kotlin_exports } from "../icons/programming-language-kotlin.svg_component.js";
import { programming_language_node_exports } from "../icons/programming-language-node.svg_component.js";
import { programming_language_objc_exports } from "../icons/programming-language-objc.svg_component.js";
import { programming_language_ocaml_exports } from "../icons/programming-language-ocaml.svg_component.js";
import { programming_language_php_exports } from "../icons/programming-language-php.svg_component.js";
import { programming_language_powershell_exports } from "../icons/programming-language-powershell.svg_component.js";
import { programming_language_python_exports } from "../icons/programming-language-python.svg_component.js";
import { programming_language_r_exports } from "../icons/programming-language-r.svg_component.js";
import { programming_language_ruby_exports } from "../icons/programming-language-ruby.svg_component.js";
import { programming_language_rust_exports } from "../icons/programming-language-rust.svg_component.js";
import { programming_language_scala_exports } from "../icons/programming-language-scala.svg_component.js";
import { programming_language_shell_exports } from "../icons/programming-language-shell.svg_component.js";
import { programming_language_swift_exports } from "../icons/programming-language-swift.svg_component.js";
import { programming_language_typescript_exports } from "../icons/programming-language-typescript.svg_component.js";
import { programming_script_code_exports } from "../icons/programming-script-code.svg_component.js";
import { programming_tool_git_exports } from "../icons/programming-tool-git.svg_component.js";
import { programming_tool_tailwindcss_exports } from "../icons/programming-tool-tailwindcss.svg_component.js";
import { Adonisjs_exports } from "../logos/Adonisjs.svg_component.js";
import { Astro_exports } from "../logos/Astro.svg_component.js";
import { Docusaurus_exports } from "../logos/Docusaurus.svg_component.js";
import { Dotnet_exports } from "../logos/Dotnet.svg_component.js";
import { Elysiajs_exports } from "../logos/Elysiajs.svg_component.js";
import { Express_exports } from "../logos/Express.svg_component.js";
import { Fastapi_exports } from "../logos/Fastapi.svg_component.js";
import { Fastify_exports } from "../logos/Fastify.svg_component.js";
import { Go_exports } from "../logos/Go.svg_component.js";
import { Hono_exports } from "../logos/Hono.svg_component.js";
import { Laravel_exports } from "../logos/Laravel.svg_component.js";
import { Litestar_exports } from "../logos/Litestar.svg_component.js";
import { Nestjs_exports } from "../logos/Nestjs.svg_component.js";
import { Nextjs_exports } from "../logos/Nextjs.svg_component.js";
import { Nitro_exports } from "../logos/Nitro.svg_component.js";
import { Nuxt_exports } from "../logos/Nuxt.svg_component.js";
import { Openapi_exports } from "../logos/Openapi.svg_component.js";
import { Platformatic_exports } from "../logos/Platformatic.svg_component.js";
import { React_exports } from "../logos/React.svg_component.js";
import { Rust_exports } from "../logos/Rust.svg_component.js";
import { Svelte_exports } from "../logos/Svelte.svg_component.js";
import { Vue_exports } from "../logos/Vue.svg_component.js";
//#region src/components/ScalarIcon/utils/index.ts
var icons = /* #__PURE__ */ Object.assign({
	"../icons/Add.svg": Add_exports,
	"../icons/AddTab.svg": AddTab_exports,
	"../icons/Alert.svg": Alert_exports,
	"../icons/ArrowLeft.svg": ArrowLeft_exports,
	"../icons/ArrowRight.svg": ArrowRight_exports,
	"../icons/Brackets.svg": Brackets_exports,
	"../icons/Branch.svg": Branch_exports,
	"../icons/Changelog.svg": Changelog_exports,
	"../icons/Checkmark.svg": Checkmark_exports,
	"../icons/ChevronDown.svg": ChevronDown_exports,
	"../icons/ChevronLeft.svg": ChevronLeft_exports,
	"../icons/ChevronRight.svg": ChevronRight_exports,
	"../icons/ChevronUp.svg": ChevronUp_exports,
	"../icons/Clipboard.svg": Clipboard_exports,
	"../icons/Close.svg": Close_exports,
	"../icons/CloseTab.svg": CloseTab_exports,
	"../icons/CloseTabs.svg": CloseTabs_exports,
	"../icons/Cloud.svg": Cloud_exports,
	"../icons/CodeFolder.svg": CodeFolder_exports,
	"../icons/Cog.svg": Cog_exports,
	"../icons/Collection.svg": Collection_exports,
	"../icons/Cookie.svg": Cookie_exports,
	"../icons/DarkMode.svg": DarkMode_exports,
	"../icons/Delete.svg": Delete_exports,
	"../icons/Discord.svg": Discord_exports,
	"../icons/DocsPage.svg": DocsPage_exports,
	"../icons/Download.svg": Download_exports,
	"../icons/Duplicate.svg": Duplicate_exports,
	"../icons/Edit.svg": Edit_exports,
	"../icons/Ellipses.svg": Ellipses_exports,
	"../icons/Email.svg": Email_exports,
	"../icons/Error.svg": Error_exports,
	"../icons/Example.svg": Example_exports,
	"../icons/ExternalLink.svg": ExternalLink_exports,
	"../icons/FilterList.svg": FilterList_exports,
	"../icons/Folder.svg": Folder_exports,
	"../icons/GitHub.svg": GitHub_exports,
	"../icons/GitHubLine.svg": GitHubLine_exports,
	"../icons/Globe.svg": Globe_exports,
	"../icons/Google.svg": Google_exports,
	"../icons/Help.svg": Help_exports,
	"../icons/Hide.svg": Hide_exports,
	"../icons/History.svg": History_exports,
	"../icons/House.svg": House_exports,
	"../icons/Import.svg": Import_exports,
	"../icons/Info.svg": Info_exports,
	"../icons/Key.svg": Key_exports,
	"../icons/Leave.svg": Leave_exports,
	"../icons/LightDarkModeToggle.svg": LightDarkModeToggle_exports,
	"../icons/LightMode.svg": LightMode_exports,
	"../icons/Link.svg": Link_exports,
	"../icons/Lock.svg": Lock_exports,
	"../icons/Logo.svg": Logo_exports,
	"../icons/Magic.svg": Magic_exports,
	"../icons/Markdown.svg": Markdown_exports,
	"../icons/Menu.svg": Menu_exports,
	"../icons/NotAllowed.svg": NotAllowed_exports,
	"../icons/Page.svg": Page_exports,
	"../icons/Pencil.svg": Pencil_exports,
	"../icons/Play.svg": Play_exports,
	"../icons/Refresh.svg": Refresh_exports,
	"../icons/Roadmap.svg": Roadmap_exports,
	"../icons/Scribble.svg": Scribble_exports,
	"../icons/Search.svg": Search_exports,
	"../icons/Server.svg": Server_exports,
	"../icons/Settings.svg": Settings_exports,
	"../icons/Show.svg": Show_exports,
	"../icons/Sort.svg": Sort_exports,
	"../icons/Terminal.svg": Terminal_exports,
	"../icons/Trash.svg": Trash_exports,
	"../icons/Unlock.svg": Unlock_exports,
	"../icons/Unwatch.svg": Unwatch_exports,
	"../icons/Upload.svg": Upload_exports,
	"../icons/User.svg": User_exports,
	"../icons/UserSwitch.svg": UserSwitch_exports,
	"../icons/Users.svg": Users_exports,
	"../icons/Versions.svg": Versions_exports,
	"../icons/Wallet.svg": Wallet_exports,
	"../icons/Watch.svg": Watch_exports,
	"../icons/Workspace.svg": Workspace_exports,
	"../icons/programming-framework-angular.svg": programming_framework_angular_exports,
	"../icons/programming-framework-astro.svg": programming_framework_astro_exports,
	"../icons/programming-framework-laravel.svg": programming_framework_laravel_exports,
	"../icons/programming-framework-nextdotjs.svg": programming_framework_nextdotjs_exports,
	"../icons/programming-framework-react.svg": programming_framework_react_exports,
	"../icons/programming-framework-vuedotjs.svg": programming_framework_vuedotjs_exports,
	"../icons/programming-language-c.svg": programming_language_c_exports,
	"../icons/programming-language-clojure.svg": programming_language_clojure_exports,
	"../icons/programming-language-csharp.svg": programming_language_csharp_exports,
	"../icons/programming-language-css3.svg": programming_language_css3_exports,
	"../icons/programming-language-dart.svg": programming_language_dart_exports,
	"../icons/programming-language-fsharp.svg": programming_language_fsharp_exports,
	"../icons/programming-language-go.svg": programming_language_go_exports,
	"../icons/programming-language-html5.svg": programming_language_html5_exports,
	"../icons/programming-language-http.svg": programming_language_http_exports,
	"../icons/programming-language-java.svg": programming_language_java_exports,
	"../icons/programming-language-javascript.svg": programming_language_javascript_exports,
	"../icons/programming-language-json.svg": programming_language_json_exports,
	"../icons/programming-language-julia.svg": programming_language_julia_exports,
	"../icons/programming-language-kotlin.svg": programming_language_kotlin_exports,
	"../icons/programming-language-node.svg": programming_language_node_exports,
	"../icons/programming-language-objc.svg": programming_language_objc_exports,
	"../icons/programming-language-ocaml.svg": programming_language_ocaml_exports,
	"../icons/programming-language-php.svg": programming_language_php_exports,
	"../icons/programming-language-powershell.svg": programming_language_powershell_exports,
	"../icons/programming-language-python.svg": programming_language_python_exports,
	"../icons/programming-language-r.svg": programming_language_r_exports,
	"../icons/programming-language-ruby.svg": programming_language_ruby_exports,
	"../icons/programming-language-rust.svg": programming_language_rust_exports,
	"../icons/programming-language-scala.svg": programming_language_scala_exports,
	"../icons/programming-language-shell.svg": programming_language_shell_exports,
	"../icons/programming-language-swift.svg": programming_language_swift_exports,
	"../icons/programming-language-typescript.svg": programming_language_typescript_exports,
	"../icons/programming-script-code.svg": programming_script_code_exports,
	"../icons/programming-tool-git.svg": programming_tool_git_exports,
	"../icons/programming-tool-tailwindcss.svg": programming_tool_tailwindcss_exports
});
var logos = /* #__PURE__ */ Object.assign({
	"../logos/Adonisjs.svg": Adonisjs_exports,
	"../logos/Astro.svg": Astro_exports,
	"../logos/Docusaurus.svg": Docusaurus_exports,
	"../logos/Dotnet.svg": Dotnet_exports,
	"../logos/Elysiajs.svg": Elysiajs_exports,
	"../logos/Express.svg": Express_exports,
	"../logos/Fastapi.svg": Fastapi_exports,
	"../logos/Fastify.svg": Fastify_exports,
	"../logos/Go.svg": Go_exports,
	"../logos/Hono.svg": Hono_exports,
	"../logos/Laravel.svg": Laravel_exports,
	"../logos/Litestar.svg": Litestar_exports,
	"../logos/Nestjs.svg": Nestjs_exports,
	"../logos/Nextjs.svg": Nextjs_exports,
	"../logos/Nitro.svg": Nitro_exports,
	"../logos/Nuxt.svg": Nuxt_exports,
	"../logos/Openapi.svg": Openapi_exports,
	"../logos/Platformatic.svg": Platformatic_exports,
	"../logos/React.svg": React_exports,
	"../logos/Rust.svg": Rust_exports,
	"../logos/Svelte.svg": Svelte_exports,
	"../logos/Vue.svg": Vue_exports
});
/**
* Generate a Vue component from the icon SVGs
*
* For any changes to this file, please ensure it works with SSR
*/
var getIcon = (name) => {
	const filename = `../icons/${name}.svg`;
	if (!icons[filename]) {
		console.warn(`Could not find icon: ${name}`);
		return null;
	}
	return icons[filename];
};
/**
* Generate a Vue component from the logo SVGs
*
* For any changes to this file, please ensure it works with SSR
*/
var getLogo = (name) => {
	const filename = `../logos/${name}.svg`;
	if (!logos[filename]) {
		console.warn(`Could not find icon: ${name}`);
		return null;
	}
	return logos[filename];
};
//#endregion
export { getIcon, getLogo };

//# sourceMappingURL=index.js.map